<template>
    <section>
        <app-drawer></app-drawer>
        <v-content>
            <v-container fluid fill-height>
                <v-layout>
                    <slot></slot>
                </v-layout>
            </v-container>
        </v-content>
    </section>
</template>

<script>
import AppDrawer from '@/components/layout/drawer.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppDrawer
  }
}
</script>
